import BaseRequest from './BaseRequest';

const schema = 'setting';
/**
 * key base on host:port
 */
export default class SettingRequest extends BaseRequest {
	version = "v1/cryptotrading-admin";

  /**
	 *
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchCoinSettings() {
    const url = `${schema}/coin-settings`;
    return this.get(url);
  }

  fetchMarkets() {
    const url = `${schema}/markets`;
    return this.get(url);
  }

  fetchAllCoins() {
    const url = `${schema}/coins`;
    return this.get(url);
  }

  // fetchLimitWithdrawal() {
  //   const url = `${schema}/limit-withdrawals`;
  //   return this.get(url);
  // }

  UpdateLimitWithdrawal(params) {
    const url = `${schema}/update-limit-withdrawal`;
    return this.post(url,params);
  }

  updateCoin(params) {
    const url = `${schema}/update-coin`;
    return this.post(url, params);
  }

  fetchCryptoSetting() {
    const url = `${schema}/crypto-setting`;
    return this.get(url);
  }

  fetchSettingHash() {
    const url = `${schema}/hash`;
    return this.get(url);
  }

  postCoinSetting(data){
    const url = `${schema}/coins`
    return this.post(url,data);
  }
  
  fetchTomoCoin(params) {
    const url = `${schema}/tomo-coins`;
    return this.post(url, params);
  }

  getToken(params){
    const url = `${schema}/token`
    return this.get(url, params);
  }

  getTomoToken(params){
    const url = `${schema}/token-tomo`
    return this.get(url, params);
  }

  createMarket(params) {
    const url = `${schema}/coin-setting`;
    return this.post(url, params);
  }

  closeMarket({ coin, currency }) {
    const url = `${schema}/coin-setting/close-market/${coin}/${currency}`;
    return this.put(url);
  }

  openMarket({ coin, currency }) {
    const url = `${schema}/coin-setting/open-market/${coin}/${currency}`;
    return this.put(url);
  }

  closeCoin(coin) {
    const url = `${schema}/coin-setting/close-coin/${coin}`;
    return this.put(url);
  }

  openCoin(coin) {
    const url = `${schema}/coin-setting/open-coin/${coin}`;
    return this.put(url);
  }

  fetchLimitAdminWithdrawal(params) {
    const url = `${schema}/admin-limit-withdrawals`;
    return this.get(url, params);
  }

  setLimitWithdrawalForAdmin(params) {
    const url = `${schema}/admin-limit-withdrawal`;
    return this.post(url, params);
  }

  fetchLimitWithdrawal(params) {
    const url = `${schema}/limit-withdrawal`;
    return this.get(url, params);
  }

  addCustomCoin(params) {
    const url = `${schema}/add-custom-coin`;
    return this.post(url, params);
  }

  fetchCryptoExchangeConfig(params) {
    const url = `${schema}/cryptoexchangeconfig`;
    return this.get(url, params);
  }

  updateCryptoExchangeConfig(params) {
    const url = `${schema}/cryptoexchangeconfig`;
    return this.put(url, params);
  }

  fetchListPublicKeyActiveListCrypto(params) {
    const url = `${schema}/listpubkeytoactivelistcryptoexchange`;
    return this.get(url, params);
  }

  deletePublicKeyActiveListCrypto(params) {
    const url = `${schema}/pubkeyactivelistcryptoexchange?pubkey=${params.pubkey}`;
    return this.del(url, params);
  }

  addPublicKeyToActiveListCrypto(params) {
    const url = `${schema}/pubkeytoactivelistcryptoexchange?pubkey=${params.pubkey}`;
    return this.put(url, params);
  }
}
